var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn btn-primary",class:{
    'w-full block': _vm.block,
    'btn-primary--outlined': _vm.outlined,
    'btn-primary--underline': _vm.underline,
    'btn-primary--custom-font': _vm.isCustomFont,
  },attrs:{"type":_vm.type,"disabled":_vm.disabled}},_vm.$listeners),[_c('span',{staticClass:"z-1 relative flex items-center justify-center leading-tight"},[(_vm.isLoading)?_c('ButtonLoader'):(!!_vm.$slots.default)?[_vm._t("default")]:[_vm._v(_vm._s(_vm.label))]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }